import { Auth } from '@aws-amplify/auth';

export const getAccessToken = async () => {
  const session = await Auth.currentSession().catch((_e) => {
    return null;
  });
  if (!session) {
    return null;
  }
  const accessToken = session.getAccessToken();
  return accessToken;
};

export const getAuthorizationHeader = async () => {
  const headers: Record<string, string> = {};
  const sessionToken = await getAccessToken();
  if (sessionToken) {
    headers['Authorization'] = `Bearer ${sessionToken.getJwtToken()}`;
  }
  return headers;
};
